import { UserActions } from "../action-types/userActionTypes";

const initialState = {
  userData: [],
  isLoading: false,
  isUserLogout: false,
  isForgotPassword: false,
  isLoginLoading: false,
  isLogOutLoading: false,
  isSaveButtonLoading: false,
  isUserAccountPwdButtonLoading: false,
  isNotificationLoading: false,
  notificationData: [],
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case UserActions.SET_LOGIN_USER_DATA:
      return {
        ...state,
        userData: action.payload.userData,
      };
    case UserActions.IS_USER_LOGOUT:
      return {
        ...state,
        isUserLogout: action.payload,
      };
    case UserActions.IS_USER_FORGOT_PASSWORD:
      return {
        ...state,
        isForgotPassword: action.payload,
      };
    case UserActions.SET_NOTIFICATION_LIST:
      return {
        ...state,
        notificationData: action.payload,
      };
    case UserActions.SET_LOADER_NOTIFICATION:
      return {
        ...state,
        isNotificationLoading: action.payload,
      };
    case UserActions.SET_LOADER:
      return {
        ...state,
        isLoading: action.payload,
      };
    case UserActions.SET_LOADER_USER_LOGIN:
      return {
        ...state,
        isLoginLoading: action.payload,
      };
    case UserActions.SET_LOADER_USER_LOGOUT:
      return {
        ...state,
        isLogOutLoading: action.payload,
      };
    case UserActions.SET_LOADER_SAVE_BUTTON:
      return {
        ...state,
        isSaveButtonLoading: action.payload,
      };
    case UserActions.SET_LOADER_UPDATE_ACCOUNT_PWD_BUTTON:
      return {
        ...state,
        isUserAccountPwdButtonLoading: action.payload,
      };
    default:
      return state;
  }
};

export default userReducer;
